import React from 'react';
import { BsFillShieldLockFill } from 'react-icons/bs';
import { useCommonAppContext } from '../contexts/CommonAppContext';
import { Outlet } from 'react-router-dom';

export default function AdminArea({
  children,
  showLock = true
}: {
  children?: React.ReactNode
  showLock?: boolean
}) {
  const { sessionUser, hasFetchedSessionUser } = useCommonAppContext();

  const canRender = hasFetchedSessionUser && sessionUser && sessionUser.is_admin;
  return (
    <div className="admin-area">
      {canRender &&
        <>
          {children ?
            children :
            <Outlet />
          }
        </>
      }

      {showLock && !canRender &&
        <div className='flex w-full h-full items-center justify-center'>
          <BsFillShieldLockFill className='text-6xl text-gray-500 mt-4' />
        </div>
      }
    </div>
  );
}; 